export const profile = {
    namespaced: true,
    state: {
        profileImage: null
    },
    getters:{
        getSelectedImage(state){
            return state.profileImage
        }
    },
    mutations:{
        setSelectedImage(state, data){
            state.profileImage = data;
        }
    },
    actions:{
        setSelectedImage({commit}, data){
            commit('setSelectedImage', data)
        }
    }
}